import { useMemo } from 'react';
import { useGetCreditPackQuery } from 'src/store/services';
import { getPriceFromNanos } from 'src/utils';
import { useGetUser } from '../userHooks';

export const useCreditPack = () => {
  const { user_id } = useGetUser();
  const { data: creditPacks } = useGetCreditPackQuery(
    { user_id },
    { skip: !user_id },
  );
  const { packs } = creditPacks ?? {};

  const formattedPacks = useMemo(() => {
    return (
      packs?.map(({ charged_amount_nanos, credited_amount_nanos }) => ({
        value: getPriceFromNanos(charged_amount_nanos),
        credit: getPriceFromNanos(credited_amount_nanos),
      })) ?? [{ value: 0, credit: 0 }]
    );
  }, [packs]);

  return useMemo(
    () => ({
      packs,
      formattedPacks,
    }),
    [packs, formattedPacks],
  );
};
